import React from 'react';
import styles from './ListItemDivider.scss';
export var ListItemDivider = function ListItemDivider() {
  return React.createElement("div", {
    className: styles.listItemLineContainer
  }, React.createElement("hr", {
    className: styles.listItemLineTop
  }), React.createElement("hr", {
    className: styles.listItemLineBottom
  }));
};